<template>
  <el-table-column
    prop="company.name"
    sortable="custom"
    label="Vevő"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      {{ scope.row.customer_name }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'company.name',
  };
</script>
